import {useState} from 'react'
import SeasonDetailsForm from './SeasonDetailsForm';
import SeasonDetailsList from './SeasonDetailsList';

const SeasonDetails = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <SeasonDetailsForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <SeasonDetailsList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}
  
    </>
  )
}

export default SeasonDetails